import BpjsIcon from 'assets/svg/search/BPJS.svg'
import PaketDataIcon from 'assets/svg/search/paket-data.svg'
import PdamIcon from 'assets/svg/search/PDAM.svg'
import PlnIcon from 'assets/svg/search/PLN.svg'
import PulsaIcon from 'assets/svg/search/Pulsa.svg'
import SearchIcon from 'assets/svg/search/search.svg'
import theme from 'common/theme'
import highlighter from 'lib/highlighter'
import AngsuranIcon from 'services/DigitalGoods/assets/angsuran.svg'
import GasIcon from 'services/DigitalGoods/assets/gas-pgn.svg'
import TVInternetIcon from 'services/DigitalGoods/assets/tv-kabel-internet.svg'
import { ISuggestionItem } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import styled from 'styled-components'

const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;

  svg {
    width: 20px;
    height: 20px;
  }
`

function DigitalGoods({
  suggestionItem,
  keywords,
  isHighlited,
}: ISuggestionItem): JSX.Element {
  const digitalGoodsMapper = {
    'airtime-pulsa': {
      icon: <PulsaIcon />,
      url: '/billing/pulsa-prabayar',
    },
    'airtime-data': {
      icon: <PaketDataIcon />,
      url: '/billing/paket-data',
    },
    'airtime-pascabayar': {
      icon: <PulsaIcon />,
      url: '/billing/pulsa-pascabayar',
    },
    'pln-prepaid': {
      icon: <PlnIcon />,
      url: '/billing/listrik-token',
    },
    'pln-postpaid': {
      icon: <PlnIcon />,
      url: '/billing/listrik-tagihan',
    },
    pdam: {
      icon: <PdamIcon />,
      url: '/billing/pdam',
    },
    'pay-tv': {
      icon: <TVInternetIcon />,
      url: '/billing/cable-tv',
    },
    telkom: {
      icon: <TVInternetIcon />,
      url: '/billing/cable-tv',
    },
    bpjs: {
      icon: <BpjsIcon />,
      url: '/billing/bpjs',
    },
    'credit-card': {
      icon: <AngsuranIcon />,
      url: '/billing/angsuran',
    },
    gas: {
      icon: <GasIcon />,
      url: '/billing/gas-pgn',
    },
    finance: {
      icon: <AngsuranIcon />,
      url: '/billing/angsuran',
    },
  }
  const handleItemClick = (categoryCode) => {
    window.location.assign(`${digitalGoodsMapper[categoryCode].url}`)
  }

  return (
    <StyledListItemResult
      onClick={() => handleItemClick(suggestionItem.category_code)}
      isHighlited={isHighlited}
      data-testId="digitalgood-item"
    >
      {digitalGoodsMapper[suggestionItem?.category_code]?.icon || (
        <SearchIcon width="13" height="13" />
      )}
      <HighlitedText
        dangerouslySetInnerHTML={{
          __html: highlighter(suggestionItem?.name, keywords),
        }}
        data-testid="digitalgood-item-text"
      />
    </StyledListItemResult>
  )
}

export default DigitalGoods
